import React,{useContext} from "react";
import { StoreContext } from "../contexts/storeContext";

export const useStore = () => React.useContext(StoreContext);
